import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_ROTATION_ITEM_LIST } from '../urls'
import ManthlyRotationItemForm from './ManthlyRotationItemForm'

export default function ManthlyRotationItemCreate({ onCancel, onSuccess, finance, rotationId }) {
    const monthCreate = usePostRequest({ url: MANTHLY_ROTATION_ITEM_LIST.replace('{rotationId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyRotationItemForm
                finance={finance}
                rotationId={rotationId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
